import numeral from 'numeral'
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['metrics'],
  data () {
    return {
      name: 'chart-analytics',
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'bottom',
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function (tooltipItem, data) {
              let d = data.datasets[tooltipItem.datasetIndex]
              return `${d.label} : ${numeral(d.data[tooltipItem.index]).format('0')}`
            }
          }
        },
        scales: {
          xAxes: [{
            stacked: false,
            gridLines : {
              display : false
            },
            ticks: {
                steps: 50,
                suggestedMax: 100
            }
          }],
          yAxes: [{
            stacked: false,
            ticks: {
                steps: 50,
                suggestedMax: 100
            }
          }]
        },
        // yAxes: [
        //   {
        //     display: true,
        //     stacked: false,
        //     ticks: {
        //       stepValue: 20,
        //       suggestedMin: 20,
        //       beginAtZero: true
        //     }
        //   }
        // ]
      },
      chartData: {
        labels: [],
        datasets: [
          {
            label: 'Visiteurs uniques',
            backgroundColor: '#e5f3f9',
            lineTension: 0.1,
            pointRadius: 3,
            pointStyle: 'rect',
            borderWidth: 3,
            fill: true,
            data: []
          },
          {
            label: 'Visites',
            backgroundColor: '#058dc7',
            lineTension: 0.1,
            pointRadius: 3,
            pointStyle: 'rect',
            borderWidth: 3,
            fill: false,
            data: []
          }
        ]
      }
    }
  },
  created () {
    this.chartData.labels = JSON.parse(JSON.stringify(Object.keys(this.metrics.visits)))
    this.chartData.datasets[0].data = JSON.parse(JSON.stringify(Object.values(this.metrics.visits)))
    this.chartData.datasets[1].data = JSON.parse(JSON.stringify(Object.values(this.metrics.unique_visitors)))
  },
  mounted () {
    this.renderChart(this.chartData, this.chartOptions)
  }
}
